<template>
<div class="Arrow">
    <svg version="1.1" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 283.5 283.5" enable-background="new 0 0 283.5 283.5" xml:space="preserve">
        <g>
            <path fill="#FFFFFF" d="M212.6,173.5v35.8l-71.5,71.6l-70.2-70.2v-35.8l57,57V2.6h26.2v229.3L212.6,173.5z" />
        </g>
    </svg>
</div>
</template>

<script>
export default {
    name: "Arrow"
};
</script>

<style scoped>
</style>
